import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';

export class ApprovalScopeOpeningInstructionsContextModel
  implements IModel<ApprovalScopeOpeningInstructionsContextModel>
{
  approvalScopeId: string = '';
  openingInstructions: string = '';
  shouldShow: boolean = false;
  canHidePreference: boolean = true;
  canChangeToDifferentCostCenter: boolean = true;

  toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  static create(input: any): ApprovalScopeOpeningInstructionsContextModel {
    if (!input) {
      return new ApprovalScopeOpeningInstructionsContextModel();
    }

    const model = ObjectMapper.deserialize<ApprovalScopeOpeningInstructionsContextModel>(
      ApprovalScopeOpeningInstructionsContextModel,
      input
    );

    model.openingInstructions = model.openingInstructions || '';
    model.canHidePreference = model.canHidePreference !== false;
    model.canChangeToDifferentCostCenter = model.canChangeToDifferentCostCenter !== false;

    return model;
  }
}
